export const leviDatabase = [
  //difference of -.1, 3 total ( 1-90 )
  {
    Identifier: "362550058",
    Product_Name_Taxonomy_US: "711 Skinny Women's Jeans (Plus Size)",
    Size_Group_Taxonomy_US: "Womens_Plus_Size",
    Gender_Taxonomy_US: "Women",
    Fit_Taxonomy_US: "Skinny",
    Stretch_Taxonomy_US: "Stretch",
    Color_Group_Taxonomy_US: "Dark Wash",
    Price: 69.5,
    Fit: "runs small",
    Waist: {
      23: 22.9,
      24: 23.9,
      25: 24.9,
      26: 25.9,
      27: 26.9,
      28: 27.9,
      29: 27.9,
      30: 29.9,
      31: 30.9,
      32: 31.9,
      33: 32.9,
    },
    Length: { 26: 25.8, 28: 27.9, 30: 29.7 },
    ImgFront:
      "https://lsco.scene7.com/is/image/lsco/362550058-front-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgSide:
      "https://lsco.scene7.com/is/image/lsco/362550058-side-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgBack:
      "https://lsco.scene7.com/is/image/lsco/362550058-back-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
  },

  {
    Identifier: "A15600003",
    Product_Name_Taxonomy_US: "Low Pitch Bootcut Women's Jeans",
    Size_Group_Taxonomy_US: "Womens",
    Gender_Taxonomy_US: "Women",
    Fit_Taxonomy_US: "Bootcut,Low Pitch",
    Stretch_Taxonomy_US: "Stretch",
    Color_Group_Taxonomy_US: "Medium Wash",
    Price: 69.5,
    Fit: "runs small",
    Waist: {
      23: 22.9,
      24: 23.9,
      25: 24.9,
      26: 25.9,
      27: 26.9,
      28: 27.9,
      29: 27.9,
      30: 29.9,
      31: 30.9,
      32: 31.9,
      33: 32.9,
    },
    Length: { 26: 25.8, 28: 27.9, 30: 29.7 },
    ImgFront:
      "https://lsco.scene7.com/is/image/lsco/A15600003-front-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgSide:
      "https://lsco.scene7.com/is/image/lsco/A15600003-side-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgBack:
      "https://lsco.scene7.com/is/image/lsco/A15600003-back-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
  },

  {
    Identifier: "A08980016",
    Product_Name_Taxonomy_US: "70's High Rise Slim Straight Women's Jeans",
    Size_Group_Taxonomy_US: "Womens",
    Gender_Taxonomy_US: "Women",
    Fit_Taxonomy_US: "70's High Rise,Slim,Straight",
    Stretch_Taxonomy_US: "Stretch",
    Color_Group_Taxonomy_US: "Medium Wash",
    Price: 108.0,
    Fit: "runs small",
    Waist: {
      23: 22.9,
      24: 23.9,
      25: 24.9,
      26: 25.9,
      27: 26.9,
      28: 27.9,
      29: 27.9,
      30: 29.9,
      31: 30.9,
      32: 31.9,
      33: 32.9,
    },
    Length: { 26: 25.8, 28: 27.9, 30: 29.7 },
    ImgFront:
    "https://lsco.scene7.com/is/image/lsco/A08980016-dynamic1-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgSide:
    "https://lsco.scene7.com/is/image/lsco/A08980016-side-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgBack:
    "https://lsco.scene7.com/is/image/lsco/A08980016-back-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
  },
  //difference of -.1, 3 total ( 1- 90 )

  //difference of -.2, 3 total ( 100- 195  )
  {
    Identifier: "527970310",
    Product_Name_Taxonomy_US: "720 High Rise Super Skinny Women's Jeans",
    Size_Group_Taxonomy_US: "Womens",
    Gender_Taxonomy_US: "Women",
    Fit_Taxonomy_US: "Super Skinny,Skinny",
    Stretch_Taxonomy_US: "Stretch",
    Color_Group_Taxonomy_US: "Dark Wash",
    Price: 69.5,
    Fit: "runs small",
    Waist: {
      23: 22.8,
      24: 23.8,
      25: 24.8,
      26: 25.8,
      27: 26.8,
      28: 27.8,
      29: 27.8,
      30: 29.8,
      31: 30.8,
      32: 31.8,
      33: 32.8,
    },
    Length: { 26: 25.8, 28: 27.9, 30: 29.7 },
    ImgFront:
      "https://lsco.scene7.com/is/image/lsco/527970310-front-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgSide:
      "https://lsco.scene7.com/is/image/lsco/527970310-side-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgBack:
      "https://lsco.scene7.com/is/image/lsco/527970310-back-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
  },

  {
    Identifier: "227910184",
    Product_Name_Taxonomy_US: "Mile High Super Skinny Women's Jeans",
    Size_Group_Taxonomy_US: "Womens",
    Gender_Taxonomy_US: "Women",
    Fit_Taxonomy_US: "Skinny,Super Skinny,Mile High",
    Stretch_Taxonomy_US: "Stretch",
    Color_Group_Taxonomy_US: "Medium Wash",
    Price: 69.5,
    Fit: "runs small",
    Waist: {
      23: 22.8,
      24: 23.8,
      25: 24.8,
      26: 25.8,
      27: 26.8,
      28: 27.8,
      29: 27.8,
      30: 29.8,
      31: 30.8,
      32: 31.8,
      33: 32.8,
    },
    Length: { 26: 25.8, 28: 27.9, 30: 29.7 },
    ImgFront:
      "https://lsco.scene7.com/is/image/lsco/227910184-front-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgSide:
      "https://lsco.scene7.com/is/image/lsco/227910184-side-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgBack:
      "https://lsco.scene7.com/is/image/lsco/227910184-back-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
  },
  {
    Identifier: "362000180",
    Product_Name_Taxonomy_US: "501 Original Fit Cropped Women's Jeans",
    Size_Group_Taxonomy_US: "Womens",
    Gender_Taxonomy_US: "Women",
    Fit_Taxonomy_US: "Boyfriend,Straight",
    Stretch_Taxonomy_US: "Stretch",
    Color_Group_Taxonomy_US: "Light Wash",
    Price: 69.5,
    Fit: "runs small",
    Waist: {
      23: 22.8,
      24: 23.8,
      25: 24.8,
      26: 25.8,
      27: 26.8,
      28: 27.8,
      29: 27.8,
      30: 29.8,
      31: 30.8,
      32: 31.8,
      33: 32.8,
    },
    Length: { 26: 25.8, 28: 27.9, 30: 29.7 },
    ImgFront:
      "https://lsco.scene7.com/is/image/lsco/362000180-front-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgSide:
      "https://lsco.scene7.com/is/image/lsco/362000180-side-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgBack:
      "https://lsco.scene7.com/is/image/lsco/362000180-back-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
  },
//difference of -.2, 3 total, ( 100-195  )

//difference of -.3, 3 total, ( 197- 292  )
  {
    Identifier: "227910147",
    Product_Name_Taxonomy_US: "Mile High Super Skinny Women's Jeans",
    Size_Group_Taxonomy_US: "Womens",
    Gender_Taxonomy_US: "Women",
    Fit_Taxonomy_US: "Skinny,Super Skinny,Mile High",
    Stretch_Taxonomy_US: "Stretch",
    Color_Group_Taxonomy_US: "Black",
    Price: 69.5,
    Fit: "runs small",
    Waist: {
      23: 22.7,
      24: 23.7,
      25: 24.7,
      26: 25.7,
      27: 26.7,
      28: 27.7,
      29: 27.7,
      30: 29.7,
      31: 30.7,
      32: 31.7,
      33: 32.7,
    },
    Length: { 26: 25.8, 28: 27.9, 30: 29.7 },
    ImgFront:
      "https://lsco.scene7.com/is/image/lsco/227910147-front-pdp-lse?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgSide:
      "https://lsco.scene7.com/is/image/lsco/227910147-side-pdp-lse?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgBack:
      "https://lsco.scene7.com/is/image/lsco/227910147-detail1-pdp-lse?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
  },

  {
    Identifier: "349640146",
    Product_Name_Taxonomy_US: "Wedgie Straight Fit Women's Jeans",
    Size_Group_Taxonomy_US: "Womens",
    Gender_Taxonomy_US: "Women",
    Fit_Taxonomy_US: "Wedgie,Straight",
    Stretch_Taxonomy_US: "Non Stretch",
    Color_Group_Taxonomy_US: "Black",
    Price: 108.0,
    Fit: "runs small",
    Waist: {
      23: 22.7,
      24: 23.7,
      25: 24.7,
      26: 25.7,
      27: 26.7,
      28: 27.7,
      29: 27.7,
      30: 29.7,
      31: 30.7,
      32: 31.7,
      33: 32.7,
    },
    Length: { 26: 25.8, 28: 27.9, 30: 29.7 },
    ImgFront:
      "https://lsco.scene7.com/is/image/lsco/349640146-front-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgSide:
      "https://lsco.scene7.com/is/image/lsco/349640146-side-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgBack:
      "https://lsco.scene7.com/is/image/lsco/349640146-back-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
  },
  {
    Identifier: "362000216",
    Product_Name_Taxonomy_US: "501® Original Cropped Women's Jeans",
    Size_Group_Taxonomy_US: "Womens",
    Gender_Taxonomy_US: "Women",
    Fit_Taxonomy_US: "Straight,Boyfriend",
    Stretch_Taxonomy_US: "Non Stretch",
    Color_Group_Taxonomy_US: "White",
    Price: 69.98,
    Fit: "runs small",
    Waist: {
      23: 22.7,
      24: 23.7,
      25: 24.7,
      26: 25.7,
      27: 26.7,
      28: 27.7,
      29: 27.7,
      30: 29.7,
      31: 30.7,
      32: 31.7,
      33: 32.7,
    },
    Length: { 26: 25.8, 28: 27.9, 30: 29.7 },
    ImgFront:
      "https://lsco.scene7.com/is/image/lsco/362000216-front-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgSide:
      "https://lsco.scene7.com/is/image/lsco/362000216-side-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgBack:
      "https://lsco.scene7.com/is/image/lsco/362000216-back-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
  },
//difference of -.3, 3 total, ( 197- 292 )

//difference of -.4, 3 total, ( 294-389  )
  {
    Identifier: "A36250002",
    Product_Name_Taxonomy_US: "726 High Rise Flare Women's Jeans (Plus Size)",
    Size_Group_Taxonomy_US: "Womens",
    Gender_Taxonomy_US: "Women",
    Fit_Taxonomy_US: "",
    Stretch_Taxonomy_US: "Non Stretch",
    Color_Group_Taxonomy_US: "Medium Wash",
    Price: 69.5,
    Fit: "runs small",
    Waist: {
      23: 22.6,
      24: 23.6,
      25: 24.6,
      26: 25.6,
      27: 26.6,
      28: 27.6,
      29: 27.6,
      30: 29.6,
      31: 30.6,
      32: 31.6,
      33: 32.6,
    },
    Length: { 26: 25.8, 28: 27.9, 30: 29.7 },
    ImgFront:
      "https://lsco.scene7.com/is/image/lsco/A36250002-front-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgSide:
      "https://lsco.scene7.com/is/image/lsco/A36250002-side-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgBack:
      "https://lsco.scene7.com/is/image/lsco/A36250002-back-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
  },
  {
    Identifier: "726930111",
    Product_Name_Taxonomy_US: "Ribcage Straight Ankle Women's Jeans",
    Size_Group_Taxonomy_US: "Womens",
    Gender_Taxonomy_US: "Women",
    Fit_Taxonomy_US: "Ribcage,Straight",
    Stretch_Taxonomy_US: "Non Stretch",
    Color_Group_Taxonomy_US: "Light Wash",
    Price: 108,
    Fit: "runs small",
    Waist: {
      23: 22.6,
      24: 23.6,
      25: 24.6,
      26: 25.6,
      27: 26.6,
      28: 27.6,
      29: 27.6,
      30: 29.6,
      31: 30.6,
      32: 31.6,
      33: 32.6,
    },
    Length: { 26: 25.8, 28: 27.9, 30: 29.7 },
    ImgFront:
      "https://lsco.scene7.com/is/image/lsco/726930111-front-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgSide:
      "https://lsco.scene7.com/is/image/lsco/726930111-side-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgBack:
      "https://lsco.scene7.com/is/image/lsco/726930111-back-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
  },
  {
    
    Identifier: "139420011",
    Product_Name_Taxonomy_US: "721 High Rise Button Front Skinny Women's Jeans",
    Size_Group_Taxonomy_US: "Womens",
    Gender_Taxonomy_US: "Women",
    Fit_Taxonomy_US: "Skinny",
    Stretch_Taxonomy_US: "Stretch",
    Color_Group_Taxonomy_US: "Pink",
    Price: 58.98,
    Fit: "runs small",
    Waist: {
      23: 22.6,
      24: 23.6,
      25: 24.6,
      26: 25.6,
      27: 26.6,
      28: 27.6,
      29: 27.6,
      30: 29.6,
      31: 30.6,
      32: 31.6,
      33: 32.6,
    },
    Length: { 26: 25.8, 28: 27.9, 30: 29.7 },
    ImgFront:
      "https://lsco.scene7.com/is/image/lsco/139420011-front-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgSide:
      "https://lsco.scene7.com/is/image/lsco/139420011-back-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgBack:
      "https://lsco.scene7.com/is/image/lsco/139420011-front-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
  },
  //difference of -.4, 3 total, ( 294- 389 )
  //difference of +.1, 3 total (390 - 486)
  {
    Identifier: "188810052",
    Product_Name_Taxonomy_US: "711 Skinny Women's Jeans",
    Size_Group_Taxonomy_US: "Womens",
    Gender_Taxonomy_US: "Women",
    Fit_Taxonomy_US: "Skinny",
    Stretch_Taxonomy_US: "Stretch",
    Color_Group_Taxonomy_US: "Black",
    Price: 89.5,
    Fit: "runs big",
    Waist: {
      23: 23.1,
      24: 24.1,
      25: 25.1,
      26: 26.1,
      27: 27.1,
      28: 28.1,
      29: 29.1,
      30: 30.1,
      31: 31.1,
      32: 32.1,
      33: 33.1,
    },
    Length: { 26: 26.2, 28: 28.2, 30: 30.3 },
    mgFront:
      "https://lsco.scene7.com/is/image/lsco/188810052-front-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgSide:
      "https://lsco.scene7.com/is/image/lsco/188810052-side-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgBack:
      "https://lsco.scene7.com/is/image/lsco/188810052-back-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
  },
  {
    Identifier: "362000236",
    Product_Name_Taxonomy_US: "501® Original Cropped Women's Jeans",
    Size_Group_Taxonomy_US: "Womens",
    Gender_Taxonomy_US: "Women",
    Fit_Taxonomy_US: "",
    Stretch_Taxonomy_US: "Non Stretch",
    Color_Group_Taxonomy_US: "Medium Wash",
    Price: 108.0,
    Fit: "runs big",
    Waist: {
      23: 23.1,
      24: 24.1,
      25: 25.1,
      26: 26.1,
      27: 27.1,
      28: 28.1,
      29: 29.1,
      30: 30.1,
      31: 31.1,
      32: 32.1,
      33: 33.1,
    },
    Length: { 26: 26.2, 28: 28.2, 30: 30.3 },

    ImgFront:
      "https://lsco.scene7.com/is/image/lsco/362000236-dynamic1-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgSide:
      "https://lsco.scene7.com/is/image/lsco/362000236-side-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgBack:
      "https://lsco.scene7.com/is/image/lsco/362000236-alt3-pdp-lse?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
  },
  {
    Identifier: "A19670001",
    Product_Name_Taxonomy_US: "Ribcage Cropped Bootcut Women's Jeans",
    Size_Group_Taxonomy_US: "Womens",
    Gender_Taxonomy_US: "Women",
    Fit_Taxonomy_US: "Bootcut,Ribcage",
    Stretch_Taxonomy_US: "Stretch",
    Color_Group_Taxonomy_US: "Medium Wash",
    Price: 69.5,
    Fit: "runs big",
    Waist: {
      23: 23.1,
      24: 24.1,
      25: 25.1,
      26: 26.1,
      27: 27.1,
      28: 28.1,
      29: 29.1,
      30: 30.1,
      31: 31.1,
      32: 32.1,
      33: 33.1,
    },
    Length: { 26: 26.2, 28: 28.2, 30: 30.3 },

    ImgFront:
      "https://lsco.scene7.com/is/image/lsco/A19670001-dynamic1-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgSide:
      "https://lsco.scene7.com/is/image/lsco/A19670001-side-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgBack:
      "https://lsco.scene7.com/is/image/lsco/A19670001-back-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
  },
  //difference of +.1, 3 total, ( 381- 486)

  //difference of +.2, 3 total, ( 485- 582 )
  {
    Identifier: "527970015",
    Product_Name_Taxonomy_US: "720 High Rise Super Skinny Women's Jeans",
    Size_Group_Taxonomy_US: "Womens",
    Gender_Taxonomy_US: "Women",
    Fit_Taxonomy_US: "Skinny,Super Skinny",
    Stretch_Taxonomy_US: "Stretch",
    Color_Group_Taxonomy_US: "Dark Wash",
    Price: 69.5,
    Fit: "runs big",
    Waist: {
      23: 23.2,
      24: 24.2,
      25: 25.2,
      26: 26.2,
      27: 27.2,
      28: 28.2,
      29: 29.2,
      30: 30.2,
      31: 31.2,
      32: 32.2,
      33: 33.2,
    },
    Length: { 26: 26.2, 28: 28.2, 30: 30.3 },

    ImgFront:
      "https://lsco.scene7.com/is/image/lsco/527970015-dynamic1-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgSide:
      "https://lsco.scene7.com/is/image/lsco/527970015-side-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgBack:
      "https://lsco.scene7.com/is/image/lsco/527970015-back-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
  },
  {
    Identifier: "196270000",
    Product_Name_Taxonomy_US: "312 Shaping Slim Fit Women's Jeans",
    Size_Group_Taxonomy_US: "Womens",
    Gender_Taxonomy_US: "Women",
    Fit_Taxonomy_US: "Slim",
    Stretch_Taxonomy_US: "Stretch",
    Color_Group_Taxonomy_US: "Black",
    Price: 69.5,
    Fit: "runs big",
    Waist: {
      23: 23.2,
      24: 24.2,
      25: 25.2,
      26: 26.2,
      27: 27.2,
      28: 28.2,
      29: 29.2,
      30: 30.2,
      31: 31.2,
      32: 32.2,
      33: 33.2,
    },
    Length: { 26: 26.2, 28: 28.2, 30: 30.3 },

    ImgFront:
      "https://lsco.scene7.com/is/image/lsco/Levis/clothing/196270000-front-pdp.jpg?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgSide:
      "https://lsco.scene7.com/is/image/lsco/Levis/clothing/196270000-side-pdp.jpg?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgBack:
      "https://lsco.scene7.com/is/image/lsco/Levis/clothing/196270000-back-pdp.jpg?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
  },
  {
    Identifier: "125010384",
    Product_Name_Taxonomy_US: "501® Original Fit Women's Jeans",
    Size_Group_Taxonomy_US: "Womens",
    Gender_Taxonomy_US: "Women",
    Fit_Taxonomy_US: "Boyfriend,Straight",
    Stretch_Taxonomy_US: "Non Stretch",
    Color_Group_Taxonomy_US: "Dark Wash",
    Price: 98.0,
    Fit: "runs big",
    Waist: {
      23: 23.2,
      24: 24.2,
      25: 25.2,
      26: 26.2,
      27: 27.2,
      28: 28.2,
      29: 29.2,
      30: 30.2,
      31: 31.2,
      32: 32.2,
      33: 33.2,
    },
    Length: { 26: 26.2, 28: 28.2, 30: 30.3 },

    ImgFront:
      "https://lsco.scene7.com/is/image/lsco/125010384-dynamic1-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgSide:
      "https://lsco.scene7.com/is/image/lsco/125010384-side-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgBack:
      "https://lsco.scene7.com/is/image/lsco/125010384-alt2-pdp-lse?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
  },
  //difference of +.2, 3 total, ( 485- 582 )

  //difference of +.3, 3 total, ( 587- 682 )

  {
    Identifier: "527970340",
    Product_Name_Taxonomy_US: "720 High Rise Super Skinny Women's Jeans",
    Size_Group_Taxonomy_US: "Womens",
    Gender_Taxonomy_US: "Women",
    Fit_Taxonomy_US: "",
    Stretch_Taxonomy_US: "Stretch",
    Color_Group_Taxonomy_US: "Medium Wash",
    Price: 98.0,
    Fit: "runs big",
    Waist: {
      23: 23.3,
      24: 24.3,
      25: 25.3,
      26: 26.3,
      27: 27.3,
      28: 28.3,
      29: 29.3,
      30: 30.3,
      31: 31.3,
      32: 32.3,
      33: 33.3,
    },
    Length: { 26: 26.2, 28: 28.2, 30: 30.3 },

    ImgFront:
      "https://lsco.scene7.com/is/image/lsco/527970340-front-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgSide:
      "https://lsco.scene7.com/is/image/lsco/527970340-side-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgBack:
      "https://lsco.scene7.com/is/image/lsco/527970340-back-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
  },
  {
    Identifier: "269860016",
    Product_Name_Taxonomy_US: "High Waisted Mom Women's Jeans",
    Size_Group_Taxonomy_US: "Womens",
    Gender_Taxonomy_US: "Women",
    Fit_Taxonomy_US: "Mom Jean,Taper",
    Stretch_Taxonomy_US: "Stretch",
    Color_Group_Taxonomy_US: "Medium Wash",
    Price: 69.5,
    Fit: "runs big",
    Waist: {
      23: 23.3,
      24: 24.3,
      25: 25.3,
      26: 26.3,
      27: 27.3,
      28: 28.3,
      29: 29.3,
      30: 30.3,
      31: 31.3,
      32: 32.3,
      33: 33.3,
    },
    Length: { 26: 26.2, 28: 28.2, 30: 30.3 },

    ImgFront:
      "https://lsco.scene7.com/is/image/lsco/269860016-front-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgSide:
      "https://lsco.scene7.com/is/image/lsco/269860016-side-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgBack:
      "https://lsco.scene7.com/is/image/lsco/269860016-back-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
  },
  {
    Identifier: "373430006",
    Product_Name_Taxonomy_US: "High Rise Straight Ankle Big Girls Jeans 7-16",
    Size_Group_Taxonomy_US: "Big Girls",
    Gender_Taxonomy_US: "Girls",
    Fit_Taxonomy_US: "Straight",
    Stretch_Taxonomy_US: "",
    Color_Group_Taxonomy_US: "Light Wash",
    Price: 44.0,
    Fit: "runs big",
    Waist: {
      23: 23.3,
      24: 24.3,
      25: 25.3,
      26: 26.3,
      27: 27.3,
      28: 28.3,
      29: 29.3,
      30: 30.3,
      31: 31.3,
      32: 32.3,
      33: 33.3,
    },
    Length: { 26: 26.2, 28: 28.2, 30: 30.3 },

    ImgFront:
      "https://lsco.scene7.com/is/image/lsco/373430006-front-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgSide:
      "https://lsco.scene7.com/is/image/lsco/373430006-alt3-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgBack:
      "https://lsco.scene7.com/is/image/lsco/373430006-alt1-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
  },
  //difference of +.3, 3 total, ( 587- 685 )
  //difference of +.4, 2 total, ( 686-751  )
  {
    Identifier: "A49690000",
    Product_Name_Taxonomy_US: "Levi's® x Danielle Guizio Classic Baggy Jeans",
    Size_Group_Taxonomy_US: "Womens",
    Gender_Taxonomy_US: "Women",
    Fit_Taxonomy_US: "",
    Stretch_Taxonomy_US: "",
    Color_Group_Taxonomy_US: "Medium Wash",
    Price: 346.0,
    Fit: "runs big",
    Waist: {
      23: 23.4,
      24: 24.4,
      25: 25.4,
      26: 26.4,
      27: 27.4,
      28: 28.4,
      29: 29.4,
      30: 30.4,
      31: 31.4,
      32: 32.4,
      33: 33.4,
    },
    Length: { 26: 26.2, 28: 28.2, 30: 30.3 },

    ImgFront:
      "https://lsco.scene7.com/is/image/lsco/A49690000-back-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgSide:
      "https://lsco.scene7.com/is/image/lsco/A49690000-alt1-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgBack:
      "https://lsco.scene7.com/is/image/lsco/A49690000-alt2-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
  },
  {
    Identifier: "188810012",
    Product_Name_Taxonomy_US: "711 Skinny Women's Jeans",
    Size_Group_Taxonomy_US: "Womens",
    Gender_Taxonomy_US: "Women",
    Fit_Taxonomy_US: "Skinny",
    Stretch_Taxonomy_US: "Stretch",
    Color_Group_Taxonomy_US: "Dark Wash",
    Price: 69.5,
    Fit: "runs big",
    Waist: {
      23: 23.4,
      24: 24.4,
      25: 25.4,
      26: 26.4,
      27: 27.4,
      28: 28.4,
      29: 29.4,
      30: 30.4,
      31: 31.4,
      32: 32.4,
      33: 33.4,
    },
    Length: { 26: 26.2, 28: 28.2, 30: 30.3 },

    ImgFront:
      "https://lsco.scene7.com/is/image/lsco/levis/clothing/188810012-front-pdp.jpg?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgSide:
      "https://lsco.scene7.com/is/image/lsco/levis/clothing/188810012-side-pdp.jpg?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgBack:
      "https://lsco.scene7.com/is/image/lsco/levis/clothing/188810012-back-pdp.jpg?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
  },
  //difference of +.4, 3 total, ( 686-751  )
  //difference of 0, 6 total, ( 752-  )
  {
    Identifier: "373500152",
    Product_Name_Taxonomy_US: "710 Super Skinny Fit Big Girls Jeans 7-16",
    Size_Group_Taxonomy_US: "Big Girls",
    Gender_Taxonomy_US: "Girls",
    Fit_Taxonomy_US: "Skinny,Super Skinny",
    Stretch_Taxonomy_US: "",
    Color_Group_Taxonomy_US: "Dark Wash",
    Price: 40.0,
    Fit: "true to size",
    Waist: {
      23: 23,
      24: 24,
      25: 25,
      26: 26,
      27: 27,
      28: 28,
      29: 29,
      30: 30,
      31: 31,
      32: 32,
      33: 33,
    },
    Length: { 26: 26, 28: 28, 30: 30 },

    ImgFront:
      "https://lsco.scene7.com/is/image/lsco/373500152-front-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgSide:
      "https://lsco.scene7.com/is/image/lsco/373500152-alt1-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgBack:
      "https://lsco.scene7.com/is/image/lsco/373500152-back-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
  },
  {
    Identifier: "362000124",
    Product_Name_Taxonomy_US: "501® Original Cropped Women's Jeans",
    Size_Group_Taxonomy_US: "Womens",
    Gender_Taxonomy_US: "Women",
    Fit_Taxonomy_US: "Straight,Boyfriend",
    Stretch_Taxonomy_US: "Non Stretch",
    Color_Group_Taxonomy_US: "Light Wash",
    Price: 108.0,
    Fit: "true to size",
    Waist: {
      23: 23,
      24: 24,
      25: 25,
      26: 26,
      27: 27,
      28: 28,
      29: 29,
      30: 30,
      31: 31,
      32: 32,
      33: 33,
    },
    Length: { 26: 26, 28: 28, 30: 30 },

    ImgFront:
      "https://lsco.scene7.com/is/image/lsco/362000124-front-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgSide:
      "https://lsco.scene7.com/is/image/lsco/362000124-side-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgBack:
      "https://lsco.scene7.com/is/image/lsco/362000124-back-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
  },
  {
    Identifier: "388430016",
    Product_Name_Taxonomy_US:
      "Ribcage Straight Ankle Women's Jeans (Plus Size)",
    Size_Group_Taxonomy_US: "Women's Plus Size",
    Gender_Taxonomy_US: "Women",
    Fit_Taxonomy_US: "Straight,Ribcage",
    Stretch_Taxonomy_US: "Stretch",
    Color_Group_Taxonomy_US: "Medium Wash",
    Price: 98.0,
    Fit: "true to size",
    Waist: {
      23: 23,
      24: 24,
      25: 25,
      26: 26,
      27: 27,
      28: 28,
      29: 29,
      30: 30,
      31: 31,
      32: 32,
      33: 33,
    },
    Length: { 26: 26, 28: 28, 30: 30 },

    ImgFront:
      "https://lsco.scene7.com/is/image/lsco/388430016-dynamic1-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgSide:
      "https://lsco.scene7.com/is/image/lsco/388430016-dynamic1-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgBack:
      "https://lsco.scene7.com/is/image/lsco/388430016-side-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
  },
  {
    Identifier: "228610107",
    Product_Name_Taxonomy_US: "Wedgie Fit Ankle Women's Jeans",
    Size_Group_Taxonomy_US: "Womens",
    Gender_Taxonomy_US: "Women",
    Fit_Taxonomy_US: "Wedgie",
    Stretch_Taxonomy_US: "Non Stretch",
    Color_Group_Taxonomy_US: "Medium Wash",
    Price: 108.0,
    Fit: "true to size",
    Waist: {
      23: 23,
      24: 24,
      25: 25,
      26: 26,
      27: 27,
      28: 28,
      29: 29,
      30: 30,
      31: 31,
      32: 32,
      33: 33,
    },
    Length: { 26: 26, 28: 28, 30: 30 },

    ImgFront:
      "https://lsco.scene7.com/is/image/lsco/228610107-front-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgSide:
      "https://lsco.scene7.com/is/image/lsco/228610107-side-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgBack:
      "https://lsco.scene7.com/is/image/lsco/228610107-back-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
  },
  {
    Identifier: "177780484",
    Product_Name_Taxonomy_US: "710 Super Skinny Women's Jeans",
    Size_Group_Taxonomy_US: "Womens",
    Gender_Taxonomy_US: "Women",
    Fit_Taxonomy_US: "",
    Stretch_Taxonomy_US: "Stretch",
    Color_Group_Taxonomy_US: "Dark Wash",
    Price: 69.5,
    Fit: "true to size",
    Waist: {
      23: 23,
      24: 24,
      25: 25,
      26: 26,
      27: 27,
      28: 28,
      29: 29,
      30: 30,
      31: 31,
      32: 32,
      33: 33,
    },
    Length: { 26: 26, 28: 28, 30: 30 },

    ImgFront:
      "https://lsco.scene7.com/is/image/lsco/177780484-front-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgSide:
      "https://lsco.scene7.com/is/image/lsco/177780484-side-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgBack:
      "https://lsco.scene7.com/is/image/lsco/177780484-back-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
  },
  {
    Identifier: "196260288",
    Product_Name_Taxonomy_US: "311 Shaping Skinny Women's Jeans",
    Size_Group_Taxonomy_US: "Womens",
    Gender_Taxonomy_US: "Women",
    Fit_Taxonomy_US: "Skinny",
    Stretch_Taxonomy_US: "Stretch",
    Color_Group_Taxonomy_US: "Medium Wash",
    Price: 46.98,
    Fit: "true to size",
    Waist: {
      23: 23,
      24: 24,
      25: 25,
      26: 26,
      27: 27,
      28: 28,
      29: 29,
      30: 30,
      31: 31,
      32: 32,
      33: 33,
    },
    Length: { 26: 26, 28: 28, 30: 30 },

    ImgFront:
      "https://lsco.scene7.com/is/image/lsco/196260288-front-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgSide:
      "https://lsco.scene7.com/is/image/lsco/196260288-side-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
    ImgBack:
      "https://lsco.scene7.com/is/image/lsco/196260288-back-pdp?fmt=avif&amp;qlt=40&amp;resMode=bisharp&amp;op_usm=0.6,0.6,8&amp;fit=crop,0&amp;wid=450&amp;hei=414",
  },
  //difference of 0, 6 total, ( 752- 946 )
];
